module.exports = __webpack_public_path__ + "img/security-code.607ac053.png";